/**
 * Access-token persistence. The token is stored in `localStorage` under a
 * stable key so it survives reloads; the fetch client (`apiClient.ts`) reads it
 * to attach the `Authorization: Bearer` header, and the auth context writes it
 * on login and clears it on logout.
 */
const ACCESS_TOKEN_KEY = 'app.accessToken'

export const tokenStorage = {
  /** The stored access token, or `null` when the user is signed out. */
  get(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
  },

  /** Persist the access token after a successful login. */
  set(token: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
  },

  /** Remove the access token on logout or a 401. */
  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
  },
}
